<template>
    <v-menu
        eager
        content-class="overflow-y-hidden dropmenu"
        top
        :close-on-content-click="false"
        offset-y
    >
        <template v-slot:activator="{ on }">
            <icon-button :icon-size="30" :on="on">
                text_format
            </icon-button>
        </template>
        <div :id="id" class="d-flex white">
            <v-btn
                v-for="(button, index) in formatButtons"
                :key="index"
                icon
                text
                class="format-button"
                style="margin: 0 1px"
                :class="button.class"
                :value="button.value"
                color="n3"
            >
                <v-icon
                    :size="button.iconSize ? button.iconSize : 24"
                    color="n3"
                >
                    {{ button.icon }}
                </v-icon>
            </v-btn>
        </div>
    </v-menu>
</template>

<script>
import {ref, computed} from "@vue/composition-api";

export default {
    name: "RichTextEditorToolbarVue",
    props: {
        id: {
            type: String,
            default: null
        },
        includeLink: {
            type: Boolean,
            default: false,
        }
    },
    setup(props) {
        const defaultFormatButtons = ref([
            {
                icon: 'mdi-format-bold',
                class: 'ql-bold'
            },
            {
                icon: 'mdi-format-italic',
                class: 'ql-italic'
            },
            {
                icon: 'mdi-format-underline',
                class: 'ql-underline'
            },
            {
                icon: 'mdi-format-list-bulleted',
                class: 'ql-list',
                value: 'bullet'
            },
            {
                icon: 'mdi-format-list-numbered',
                class: 'ql-list',
                value: 'ordered'
            },
            {
                icon: 'mdi-format-indent-decrease',
                class: 'ql-indent',
                value: '-1'
            },
            {
                icon: 'mdi-format-indent-increase',
                class: 'ql-indent',
                value: '+1'
            },
        ])

        const formatButtons = computed(() => {
            const buttons = [...defaultFormatButtons.value]

            if (props.includeLink) {
                const linkButton = {icon: 'mdi-link', class: 'ql-link'}
                buttons.push(linkButton)
            }

            return buttons
        })

        return {
            formatButtons
        }
    }
}
</script>

<style scoped lang="scss">
.ql-toolbar {
    padding: 2px !important;
}

.format-button {
    height: 32px !important;
    width: 32px !important;

    &:focus, &.ql-active {
        &::before {
            opacity: 0.3 !important;
        }

        .v-icon {
            color: var(--v-n5-base) !important;
        }
    }

    &:hover {
        &::before {
            opacity: 0.1;
        }
    }
}

</style>